import { ComplementaryItem } from '@models/balance/ComplementaryItem'
import {
  SBAsyncSelect,
  SBAsyncSelectProps,
} from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form, Input, InputNumber } from 'antd'
import { useCallback } from 'react'

const initialValues = {
  quantity: 1,
}

type Props = SBRMFormActionProps & {
  error?: string
}

const Create = ({ form, formProps, error }: Props) => {
  const { metadata, getMetadata } = useSBRMForm()

  const programId: () => number = useCallback(
    () => getMetadata(MetadataKey.Program),
    [getMetadata, metadata]
  )

  return (
    <Form
      {...formProps}
      form={form}
      layout="vertical"
      initialValues={initialValues}
    >
      <Form.Item
        name="program"
        rules={[]}
        hidden
        style={{ display: 'none' }}
        initialValue={programId()}
      >
        <Input type="hidden" />
      </Form.Item>

      <Form.Item
        name="complementaryItem"
        label={'Complementary item'}
        rules={[requiredRule()]}
        validateStatus={error && 'error'}
        help={error}
      >
        <SBAsyncSelect<ComplementaryItem>
          entity={Entity.complementaryItem}
          initialQuery={
            {
              ...initialQuery,
              filters: { programs: [programId()] },
            } as SBAsyncSelectProps<ComplementaryItem>['initialQuery']
          }
        />
      </Form.Item>

      <Form.Item name="quantity" label={'Quantity'} rules={[requiredRule()]}>
        <InputNumber mode="spinner" style={{ width: '100%' }} min={1} />
      </Form.Item>
    </Form>
  )
}

export default Create
